import { Grid } from '@material-ui/core';
import { Dispatch, VFC } from 'react';
import { useHooks } from './useHooks';
import { useStyles } from './useStyles';
import { BaseModal } from '../../../molecules/BaseModal';

export type Props = {
  isOpen: boolean;
  setIsOpen: Dispatch<boolean>;
  afterSubmit: () => void;
  constructId: number;
  constructName: string;
};

export const AllSiteProcessDeleteModal: VFC<Props> = props => {
  const { isOpen, setIsOpen, afterSubmit, constructId, constructName } = props;
  const classes = useStyles();

  const { cancelSubmit, submit } = useHooks({
    isOpen,
    setIsOpen,
    afterSubmit,
    constructId
  });

  return (
    <BaseModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      handleSubmit={submit}
      handleCancelSubmit={cancelSubmit}
      title={'全工程の削除'}
      buttonCaption={'すべて削除する'}
      cancelButtonCaption={'キャンセル'}
      isDeleteButton={true}
    >
      <Grid item xs={12} className={classes.modalCaption}>
        {constructName}の全工程を削除します。
        <br />
        よろしいですか？
      </Grid>
    </BaseModal>
  );
};
